// @flow
import _ from 'lodash'
import { connect } from 'react-redux'
import PriceInput from './PriceInput'
import type { Store } from '../../redux/ducks'
import { Audience } from '../constants'
import calculatePriceConstraints from './calculatePriceConstraints'
import { patch } from '../AudienceEditContainer'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial
  if (!initial) return {}

  const { defaultEstimates, priceConstraints } = initial
  const { placementTypes, paymentType, audienceType, providers } = audienceState
  const isAuto = paymentType === Audience.payment_types.auto
  const estimates = defaultEstimates[audienceType][placementTypes[0]][paymentType]
  const calculatedPriceConstraints = calculatePriceConstraints(
    priceConstraints[paymentType],
    providers
  )

  return {
    errors: audienceState.priceErrors,
    value: audienceState.price,
    min: isAuto ? 0 : _.min(calculatedPriceConstraints.minimum),
    maxAlert: isAuto ? 0 : priceConstraints.recommended[paymentType],
    minRecommended: isAuto ? 0 : estimates.minimal,
    effectivePrice: isAuto ? 0 : estimates.recommended,
    isLoading: audienceState.priceRecommendationsIsLoading,
    hide: audienceState.paymentType === Audience.payment_types.auto,
    paymentType: audienceState.paymentType
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (value: string) => patch(dispatch, { price: value })
  }
}

const PriceInputContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(PriceInput)

export default PriceInputContainer
